const STORAGE_KEY = 'eco-platform.dev-auth-token';

export function readDevAuthToken(): string | null {
  if (!import.meta.env.DEV) return null;
  return window.localStorage.getItem(STORAGE_KEY);
}

export function writeDevAuthToken(token: string): void {
  if (!import.meta.env.DEV) return;
  window.localStorage.setItem(STORAGE_KEY, token);
}

// Always clears — intentionally not gated; defense in depth so a stale
// token can't persist if it ever lands in a production-deployed asset.
export function clearDevAuthToken(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}

const SESSION_EXPIRED_KEY = 'eco-platform.dev-session-expired';

/**
 * Integration-test knob simulating AuthKit's post-refresh-failure state:
 * while set, `DevAuthProvider` keeps `user` populated but rejects every
 * `getAccessToken` with `LoginRequiredError`, and its `signIn()` clears the
 * flag + reloads (the "successful hosted re-sign-in"). Lets Playwright
 * exercise the shell's session-expiry branch without a real IdP.
 */
export function readDevSessionExpired(): boolean {
  if (!import.meta.env.DEV) return false;
  return window.localStorage.getItem(SESSION_EXPIRED_KEY) === '1';
}

export function clearDevSessionExpired(): void {
  window.localStorage.removeItem(SESSION_EXPIRED_KEY);
}
